import { render, staticRenderFns } from "./LanguageTranslator.vue?vue&type=template&id=90d0449c&scoped=true"
import script from "./LanguageTranslator.vue?vue&type=script&lang=js"
export * from "./LanguageTranslator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d0449c",
  null
  
)

export default component.exports